import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import config from "../../config";
import Dataloader from "../../Component/Dataloader";
import NoData from "../../Component/NoData";

export default function PaymentMethods() {
  const [exist, setExist] = useState(true);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${config.apiUrl}/config`);
      setData(response.data.payment_method);
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setExist(false);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <div className="page-content">
      <div className="product-hero-area">
        <div className="product-hero-content">
          <h4 className="mb-1">Payment Methods</h4>
          <p className="mb-0">
            Unveiling the story behind our passion and purpose
          </p>
        </div>
      </div>
      <div className="container-fluid policy_content">
        <div className="row-layout my-3 border border-secondary border-2">
          <div className="row">
            <div className="col-lg-12">
              {loading ? (
                <div className="d-flex justify-content-center">
                  <Dataloader />
                </div>
              ) : (
                <>
                  {exist ? (
                    <div dangerouslySetInnerHTML={{ __html: data }} />
                  ) : (
                    <NoData />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
